import {SessionService} from 'src/app/services/session.service';
import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Session} from 'src/app/entities/session';
import {NgForm, FormGroupDirective, FormControl, FormBuilder, Validators, FormGroup} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import {Agenda} from "../../../entities/agenda";
import {AgendaService} from "../../../services/agenda.service";
import {combineLatest, Subscription} from 'rxjs';
import {StorageMap} from "@ngx-pwa/local-storage";
import {ToastrService} from "ngx-toastr";
import {map, mergeMap, tap} from "rxjs/operators";
import {Router} from "@angular/router";


@Component({
    selector: 'app-add-session',
    templateUrl: './add-session.component.html',
    styleUrls: ['./add-session.component.css']
})
export class AddSessionComponent implements OnInit {

    constructor(private sessionService: SessionService,
                private agendaService: AgendaService,
                private storage: StorageMap,
                private toastr: ToastrService,
                private dialogRef: MatDialogRef<AddSessionComponent>,
                private  router: Router,
                @Inject(MAT_DIALOG_DATA) public data: AddSessionComponent) {
    }

    agenda: Agenda;
    agendaId: number = this.data.agendaId;
    editMode: boolean = this.data.editMode;
    session: Session = this.data.session;
    dataSubscription: Subscription;
    openSpaceId: number;
    agendaStartTime: number;
    sessionStartTime: number;
    matcher = new MyErrorStateMatcher();
    duration = new FormControl('', [Validators.required,]);
    startTime = new FormControl('', [Validators.required,]);
    formGroup = new FormGroup({duration: this.duration, startTime: this.startTime});
    sessionSaved: Session;

    ngOnInit() {
        this.loadcontent();

        if (this.session) {
            this.duration.setValue(this.session.minutesDuration);
            this.startTime.setValue(this.session.startTime);
        }
    }

  onSubmit() {
    this.matcher.submited = true;
    if (this.formGroup.invalid) {
      return;
    }
    if (this.session) {
      this.agendaService.getAdminAgenda(this.openSpaceId).subscribe(
        data => {
          this.sessionStartTime = this.formGroup.get('startTime').value;
          if (this.sessionStartTime < data.Agendas[0].startTime) {
            this.toastr.error("La hora de inicio de la sesión debe ser posterior o igual a la del evento");
          } else {
            this.transformTosession();
            this.updateSession();
          }
        },
        error => {
          console.error(error);
        });

    } else {
      this.session = new Session();
      this.transformTosession();
      this.sessionSaved = this.session;
      this.onClose();
      //this.addSession();
    }
  }

    updateSession() {
        if (this.formGroup.get('duration').value > 0) {
            this.sessionService.updateSession(this.session.id, this.session).pipe(
                tap(t => {
                    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                    this.router.onSameUrlNavigation = 'reload';
                    this.router.navigate(['/agenda']);
                })
            )
                .subscribe(
                    (_) => {
                        this.toastr.success("Sesión actualizada");
                        this.onClose();
                    },
                    error => {
                        console.error(error);
                    }
                );
        } else {
            this.toastr.error("La duración de la sesión debe ser mayor a 0 minutos");
        }
    }

    onClose() {
        this.dialogRef.close(this.sessionSaved);
    }

    loadcontent() {
        this.dataSubscription = this.storage.watch('selectedOpenId', {type: 'string'})
            .subscribe((openId) => {
                const openIdInt = parseInt(openId, 10);
                if (!isNaN(openIdInt) && openIdInt !== this.openSpaceId) {
                    this.openSpaceId = openIdInt;
                }
            });
    }

    transformTosession() {
      if(this.formGroup.get('duration').value > 0){
        this.session.minutesDuration = this.formGroup.get('duration').value;
        this.session.startTime = this.formGroup.get('startTime').value;
        this.session.agendaId = this.agendaId;
      }
    }
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
    submited = false;

    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = this.submited;
        return !!(control && control.invalid && (isSubmitted));
    }
}


